import { endOfYear, format, parse, startOfYear } from 'date-fns';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { DateField } from 'telia-front-react';
export const DATE_FORMAT = 'dd.MM.yyyy';
const formatDate = (value) => {
    return format(value, DATE_FORMAT);
};
const DateFieldContainer = (props) => {
    const { field, helpMessage, errorMessage, translateStore: { translate } } = props;
    const stringToDatepickerValue = (value) => {
        const date = value && parse(value, DATE_FORMAT, Date.now());
        if (date) {
            field.setValue(formatDate(date));
        }
        else {
            field.setValue('');
        }
        return date;
    };
    const [datepickerValue, setDatepickerValue] = React.useState(stringToDatepickerValue(field.getValue()));
    const createDateRange = (minDate, maxDate) => {
        return {
            from: minDate ? parse(minDate, DATE_FORMAT, Date.now()) : startOfYear(new Date(1900, 1)),
            to: maxDate ? parse(maxDate, DATE_FORMAT, Date.now()) : endOfYear(new Date(2100, 12))
        };
    };
    const handleToggle = (isOpen) => {
        setTimeout(() => {
            if (!isOpen) {
                setDatepickerValue(stringToDatepickerValue(field.getValue()));
            }
        });
    };
    return (React.createElement(DateField, { id: `field-${field.id}`, label: field.label, helpMessage: helpMessage, errorMessage: errorMessage, value: datepickerValue, onChange: (value) => setDatepickerValue(value), onToggle: handleToggle, datepicker: {
            range: field.limitDateRange && createDateRange(field.minDate, field.maxDate),
            onSubmit: () => field.setValue(formatDate(datepickerValue)),
            onClear: () => setDatepickerValue(stringToDatepickerValue('')),
            clearButtonLabel: translate('clearButtonLabel'),
            submitButtonLabel: translate('dateField.submitButtonLabel')
        }, required: field.isRequired }));
};
export default inject('translateStore')(observer(DateFieldContainer));
//# sourceMappingURL=Datepicker.js.map